module.exports = __webpack_public_path__ + "img/css.de1496b3.png";